import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  public customizer: string = '';
  public subtitle = signal<string | undefined>(undefined);

  public config = {
    settings: {
      layout_type: 'ltr',
      layout_version: 'dark-sidebar',
      sidebar_type: 'compact-wrapper',
      icon: 'stroke-svg'
    },
    color: {
      primary_color: 'var(--primary)',
      secondary_color: '#48A3D7'
    }
  };

  private activeCalls = signal(0);
  public readonly loading = computed(() => this.activeCalls() > 0);

  constructor() {}

  show() {
    this.activeCalls.update((count) => count + 1);
  }

  hide() {
    this.activeCalls.update((count) => (count > 0 ? count - 1 : 0));
  }

  showMax() {
    this.activeCalls.update((count) => count + 10);
  }

  hideMax() {
    this.activeCalls.set(0);
  }

  reset() {
    this.activeCalls.set(0);
  }

  isMobile(): boolean {
    return typeof window !== 'undefined' && window.matchMedia('(max-width: 767.98px)').matches;
  }
}
